import { Hand, Palette, Users, FlaskConical, Blocks } from "lucide-react";

const PROGRAMS = [
  {
    icon: Hand,
    title: "Hands-On Activities",
    desc: "Engaging activities that spark curiosity and creativity!",
    color: "teal",
  },
  {
    icon: Palette,
    title: "Arts & Crafts",
    desc: "Create, imagine and express through art!",
    color: "pink",
  },
  {
    icon: Users,
    title: "Child Care Available",
    desc: "Safe, reliable and nurturing care you can trust.",
    color: "yellow",
  },
  {
    icon: FlaskConical,
    title: "STEM Projects",
    desc: "Explore science, tech, engineering and more!",
    color: "green",
  },
  {
    icon: Blocks,
    title: "Creative Play",
    desc: "Imaginative play that builds confidence and joy!",
    color: "teal",
  },
];

const ICON_BG = {
  teal: "bg-teal-400",
  pink: "bg-pink-500",
  yellow: "bg-yellow-400",
  green: "bg-emerald-500",
};

const TITLE_COLOR = {
  teal: "text-teal-600",
  pink: "text-pink-500",
  yellow: "text-yellow-500",
  green: "text-emerald-600",
};

export const Programs = () => (
  <section id="programs" data-testid="programs-section" className="bg-yellow-50 py-16 sm:py-24">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center mb-14">
        <h2 className="font-display font-bold text-teal-600 text-4xl sm:text-5xl">Our Programs</h2>
        <p className="font-display font-semibold text-pink-500 text-xl mt-2">Fun. Friends. Discovery.</p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6">
        {PROGRAMS.map((p) => {
          const Icon = p.icon;
          return (
            <div
              key={p.title}
              data-testid={`program-card-${p.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="bg-white rounded-3xl p-7 border-4 border-transparent hover:border-pink-400 hover:-translate-y-2 transition-all duration-300 text-center flex flex-col items-center shadow-pop-teal"
            >
              <div className={`${ICON_BG[p.color]} w-20 h-20 rounded-full flex items-center justify-center mb-5 shadow-md`}>
                <Icon className="w-10 h-10 text-white" strokeWidth={2.2} />
              </div>
              <h3 className={`font-display font-bold text-lg uppercase ${TITLE_COLOR[p.color]} leading-tight`}>
                {p.title}
              </h3>
              <p className="mt-3 text-emerald-800 font-medium text-sm leading-relaxed">{p.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
